import {React, useEffect, useState} from 'react';
import { useLocation } from "react-router-dom";import './contact.css';
import Header2 from '../../header2/index-two';
import { Footer2 } from '../../footer2';
import { Phone, Mail, MapPin } from 'react-feather';
import axiosInstance from '../../../services/axiosInstance';
import { toast, ToastContainer } from "react-toastify";
import InputMask from 'react-input-mask';
import usePageTracking from '../../../hooks/usePageTracking';


const Contact = () => {
    usePageTracking("contact");

    const { pathname } = useLocation();
    
      useEffect(() => {
        // Anında yukarı sıfırla (hiç animasyon yok)
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant"   // <--- ÖNEMLİ KISIM
        });
      }, [pathname]);

    const [formData, setFormData] = useState({
        namesurname: "",
        subject: "",
        email: "",
        phone: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.namesurname || !formData.subject || !formData.email || !formData.message) {
            toast.error("Lütfen tüm gerekli alanları doldurun.");
            return;
        }

        setLoading(true);

        try {
            const res = await axiosInstance.post(
                "mail/contactMail",
                formData
            );

            toast.success("Mesajınız başarıyla gönderildi!");

            // Formu temizle
            setFormData({
                namesurname: "",
                subject: "",
                email: "",
                phone: "",
                message: ""
            });

        } catch (error) {
            toast.error("Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-wrapper" style={{ background: '#f8fafc', minHeight: '100vh' }}>
            <Header2 />
            <div className="container">
                <div className="contact-container">
                    <div className="main-container">

                        {/* Header Section */}
                        <section className="header-section">
                            <div className="header-background">
                                <section className="header-content">
                                    <div className="header-container">
                                        <div className="header-inner">
                                            <div className="header-margin">
                                                <div className="header-title-container">
                                                    <div className="heading-2">
                                                        <h2>İletişim</h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="header-description-margin">
                                                <div className="header-description-container">
                                                    <div className="description-text">
                                                        Sorularınız, önerileriniz veya iş birlikleri için bizimle iletişime geçin.
                                                        Idealonline ekibi olarak sizden gelecek her geri bildirimi önemsiyor,
                                                        bilgiye erişimi birlikte geliştirmeyi hedefliyoruz.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </section>

                        {/* Contact Form & Info Section */}
                        <section className="contact-form-section">
                            <div className="contact-border">
                                <section className="contact-info-section">
                                    <div className="contact-info-container">

                                        {/* Contact Info Column */}
                                        <div className="contact-info-column">
                                            <div className="contact-info-inner">

                                                <div className="contact-heading-margin">
                                                    <div className="contact-heading-container">
                                                        <h2>Bize Ulaşın</h2>
                                                    </div>
                                                </div>

                                                {/* Phone */}
                                                <div className="contact-item-margin">
                                                    <div className="contact-item-container">
                                                        <div className="contact-icon-container">
                                                            <div className="contact-icon">
                                                                <Phone size={44} />
                                                            </div>
                                                        </div>
                                                        <div className="contact-text-container">
                                                            <h3>Telefon</h3>
                                                            <div className="contact-detail">+90 212 528 85 41</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Email */}
                                                <div className="contact-item-margin">
                                                    <div className="contact-item-container">
                                                        <div className="contact-icon-container">
                                                            <div className="contact-icon">
                                                                <Mail size={44} />
                                                            </div>
                                                        </div>
                                                        <div className="contact-text-container">
                                                            <h3>E-Posta</h3>
                                                            <div className="contact-detail">idealonline@idealkultur.com</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Address */}
                                                <div className="contact-address-container">
                                                    <div className="contact-address-row">
                                                        <div className="contact-icon-container">
                                                            <div className="contact-icon">
                                                                <MapPin size={44} />
                                                            </div>
                                                        </div>
                                                        <div className="contact-address-text">
                                                            <h3>Adres</h3>
                                                            <div className="contact-detail">
                                                                Topkapı Mahallesi Kahalbaşı Sokak, No: 31/1 34093,
                                                                Fatih, İstanbul / Türkiye
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        {/* Form Column */}
                                        <div className="contact-form-column">
                                            <div className="contact-form-inner">
                                                <form className="contact-form" onSubmit={handleSubmit}>

                                                    <div className="form-row">

                                                        {/* Name */}
                                                        <div className="form-field">
                                                            <div className="input-container">
                                                                <input
                                                                    type="text"
                                                                    name="namesurname"
                                                                    placeholder="İsim Soyisim"
                                                                    className="form-input"
                                                                    value={formData.namesurname}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Subject */}
                                                        <div className="form-field">
                                                            <div className="select-container">
                                                                <select
                                                                    name="subject"
                                                                    className="form-select"
                                                                    value={formData.subject}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Konu seçiniz</option>
                                                                    <option value="general">Genel Soru</option>
                                                                    <option value="support">Destek</option>
                                                                    <option value="collaboration">İş Birliği</option>
                                                                    <option value="other">Diğer</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        {/* Email */}
                                                        <div className="form-field">
                                                            <div className="input-container">
                                                                <input
                                                                    type="email"
                                                                    name="email"
                                                                    placeholder="E-Posta Adresiniz"
                                                                    className="form-input"
                                                                    value={formData.email}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Phone */}
                                                        <div className="form-field">
                                                            <div className="input-container">
                                                                <InputMask
                                                                    mask="+99(999)9999999"
                                                                    value={formData.phone}
                                                                    onFocus={() => {
                                                                        if (!formData.phone || formData.phone.replace(/\D/g, '').length === 0) {
                                                                            setFormData({ ...formData, phone: '+90' });
                                                                        }
                                                                    }}
                                                                    onChange={handleChange}
                                                                >
                                                                    {(inputProps) => (
                                                                        <input
                                                                            {...inputProps}
                                                                            type="tel"
                                                                            name="phone"
                                                                            placeholder="+90(555)0000000"
                                                                            className="form-input"
                                                                            required
                                                                        />
                                                                    )}
                                                                </InputMask>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    {/* Message */}
                                                    <div className="form-message-row">
                                                        <div className="form-message-field">
                                                            <div className="textarea-container">
                                                                <textarea
                                                                    name="message"
                                                                    placeholder="Mesajınız"
                                                                    className="form-textarea"
                                                                    rows="4"
                                                                    value={formData.message}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Submit */}
                                                    <div className="form-submit-row">
                                                        <button
                                                            type="submit"
                                                            className="submit-button"
                                                            disabled={loading}
                                                            style={{
                                                                opacity: loading ? 0.6 : 1,
                                                                cursor: loading ? "not-allowed" : "pointer"
                                                            }}
                                                        >
                                                            {loading ? "Gönderiliyor..." : "Gönder"}
                                                        </button>
                                                    </div>

                                                </form>
                                            </div>
                                        </div>

                                    </div>
                                </section>

                                {/* Map Section */}
                                <section className="map-section">
                                    <div className="map-container">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.146717152924!2d28.928159077478064!3d41.02204597134854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caba3f46618791%3A0xd6187776250a1bb3!2zxLBkZWFsIEvDvGx0w7xyIFlhecSxbmPEsWzEsWs!5e0!3m2!1str!2str!4v1762515634113!5m2!1str!2str"
                                            width="100%"
                                            height="100%"
                                            style={{ border: 0, borderRadius: '20px' }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            title="İdeal Kültür Yayıncılık"
                                        ></iframe>
                                    </div>
                                </section>

                            </div>
                        </section>

                    </div>
                </div>
            </div>

            <Footer2 />
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    );
};

export default Contact;
